<!-- 位度系统对接 最新设备状态汇总 -->
<template>
  <dev>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange" :beforeOpen="beforeOpen"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
    </avue-crud>
  </dev>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import {getList, add, update, remove, getDetail} from "./api";
import {searchTimeConfig} from "@/basic-common/util/common";

export default {
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: {getList, add, update, remove, getDetail},
      infoCardData: [], // 卡片数据
      option: {
        ...this.$store.state.publicOption,
        column: [
          {
            label: '汇总日期',
            prop: 'summaryDate',
            type: 'date',
            search: true,
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            rules: [
              {required: true, message: '请选择汇总日期', trigger: 'blur'}
            ],
            // 可以设置默认值为今天
            value: this.getTodayDate()
          },
          {
            label: '设备ID',
            prop: 'deviceId',
          },
          {
            label: '设备标签ID',
            prop: 'tagId',
            search: true,
            rules: [
              {required: true, message: '设备标签ID不能为空', trigger: 'blur'},
            ]
          },
          {
            label: '在线时长(分钟)',
            prop: 'onlineDuration',
            type: 'number',
            min: 0,
            value: 0,
            rules: [
              {required: true, message: '在线时长不能为空', trigger: 'blur'},
            ]
          },
          {
            label: '定位点数量',
            prop: 'positionCount',
            type: 'number',
            min: 0,
            value: 0,
            rules: [
              {required: true, message: '定位点数量不能为空', trigger: 'blur'},
            ]
          },
          {
            label: '平均卫星数量',
            prop: 'avgSatelliteCount',
            type: 'number',
            min: 0,
            precision: 1,
            value: 0.0,
            rules: [
              {required: true, message: '平均卫星数量不能为空', trigger: 'blur'},
            ]
          },
          {
            label: '平均信号强度',
            prop: 'avgSignalStrength',
            search: false, // 查询是否显示
            type: 'number',
            min: 0,
            precision: 1,
            value: 0.0,
            rules: [
              {required: true, message: '平均信号强度不能为空', trigger: 'blur'},
            ]
          },
          {
            label: '有效定位点数量',
            prop: 'validPositionCount',
            type: 'number',
            min: 0,
            value: 0,
            rules: [
              {required: true, message: '有效定位点数量不能为空', trigger: 'blur'},
            ]
          },
          {
            label: '最后纬度',
            prop: 'lastLatitude',
            type: 'number',
            precision: 8,
            rules: [
              {validator: this.validateLatitude, trigger: 'blur'}
            ]
          },
          {
            label: '最后经度',
            prop: 'lastLongitude',
            type: 'number',
            precision: 8,
            rules: [
              {validator: this.validateLongitude, trigger: 'blur'}
            ]
          },
          {
            label: '最后电量',
            prop: 'lastPower',
            type: 'number',
            min: 0,
            max: 100,
            rules: [
              {type: 'number', min: 0, max: 100, message: '电量必须在0-100之间', trigger: 'blur'}
            ]
          },
          {
            label: '最后在线时间',
            prop: 'lastOnlineTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            minWidth: 120,
          },
          {
            label: '备注',
            prop: 'remark',
            type: "textarea",
            span: 24,
            minRows: 3,
            hide: true,
            search: false, // 不参与查询
            rules: [
              {max: 500, message: '备注不能超过500个字符', trigger: 'blur'}
            ]
          },
          {
            ...searchTimeConfig,
            paramsKey: ["startTime", "endTime"],
            search: false, // 不参与查询
          },
        ]
      },
    }
  },
  methods: {
    /**
     * 获取今天日期的字符串（yyyy-MM-dd格式）
     */
    getTodayDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    /**
     * 在打开对话框前设置默认值
     */
    beforeOpen(done, type) {
      if (type === 'add') {
        // 新增时设置默认值
        this.$nextTick(() => {
          this.form.summaryDate = this.getTodayDate();
          this.form.status = 1;
          this.form.onlineDuration = 0;
          this.form.positionCount = 0;
          this.form.avgSatelliteCount = 0.0;
          this.form.avgSignalStrength = 0.0;
          this.form.validPositionCount = 0;
          this.form.tenantId = '622550';
        });
      }
      done();
    },
    /**
     * 验证小数位数
     */
    validateDecimal(rule, value, callback) {
      if (value === null || value === undefined || value === '') {
        callback();
        return;
      }
      const precision = rule.precision || 1;
      const regex = new RegExp(`^-?\\d+(\\.\\d{1,${precision}})?$`);
      if (!regex.test(value.toString())) {
        callback(new Error(rule.message || `最多只能保留${precision}位小数`));
      } else {
        callback();
      }
    },

    /**
     * 验证纬度范围 (-90 到 90)
     */
    validateLatitude(rule, value, callback) {
      if (value === null || value === undefined || value === '') {
        callback();
        return;
      }
      if (value < -90 || value > 90) {
        callback(new Error('纬度范围必须在-90到90之间'));
      } else {
        callback();
      }
    },

    /**
     * 验证经度范围 (-180 到 180)
     */
    validateLongitude(rule, value, callback) {
      if (value === null || value === undefined || value === '') {
        callback();
        return;
      }
      if (value < -180 || value > 180) {
        callback(new Error('经度范围必须在-180到180之间'));
      } else {
        callback();
      }
    }
  }
}
</script>
<style scoped lang="scss">
</style>
